import React from "react";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";


function CardMessage({status}) {

  if (!status)
    return (
      <Alert
        message="شما هنوز درخواست کارت عضویت خود را ثبت نکرده اید. "
        type="warning"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" danger>
            <Link to="/setting/card"> ثبت درخواست</Link>
          </Button>
        }
      />
    );
  if (status === "ISSUING") {
    return (
      <Alert
        message="درخواست صدور کارت شما توسط مدیریت در حال پیگیری است."
        type="info"
        banner
      />
    );
  }
  if (status === "DELIVERING") {
    return (
      <Alert
        message="کارت عضویت شما صادر شده. برای تحویل به مدیریت مجموعه مراجعه کنید."
        type="info"
        banner
      />
    );
  }
  return
}
export default CardMessage;
